import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';

export const Table = styled.table`
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
`;